import { createSlice } from "@reduxjs/toolkit";
import { VISA_TYPE_ID } from "libs/configs/constant";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import { getRouterChangeSmartByConditionType } from "libs/utils/changeSmart";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import { get } from "lodash-es";
import { getSmartForm } from "redux/modules/visaForm/actions";

let initialState = {
  smartFormStep: "none",
  homeTab: HOME_TAB.INFORMATION,
  isExtension: false,
  isChange: false,
  typeChange: "",
  router: {
    request: [],
  },
  stack: [],
};

const uiSlice = createSlice({
  name: "ui",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
    setSmartFormStep(state, action) {
      state.smartFormStep = action.payload;
    },
    setSmartFormBackStep(state, action) {
      if (state.smartFormStep !== "none" && state.stack?.length > 0) {
        state.smartFormStep = state.stack.pop();
      }
    },
    setHomeTab(state, action) {
      state.homeTab = action.payload;
    },
    clearSmartFormStep(state) {
      state.smartFormStep = initialState.smartFormStep;
      state.router = initialState.smartFormStep;
      state.stack = initialState.smartFormStep;
    },
    setIsExtension(state, action) {
      state.isExtension = action.payload;
    },
    setIsChange(state, action) {
      state.isChange = action.payload;
    },
    initRouter(state, action) {
      state.router = action.payload;
    },
    setTypeChange(state, action) {
      state.typeChange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSmartForm.fulfilled, (state, action) => {
      state.router = {
        request: [],
      };

      const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
      const smartformDetail = get(action.payload, "detail", []).reduce(
        smartNameById,
        {}
      );
      const ConditionType = get(smartformDetail, "ConditionType.value", "");
      const isGovernment = !(
        ConditionType === "Start up" || ConditionType === "Company"
      );

      // Request smart form
      switch (action.payload.smartserviceId) {
        case VISA_TYPE_ID.SMART_T: {
          if (isGovernment) {
            state.router.request = [
              SMART_T_STEP.UPLOAD_PASSPORT,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_A_2,
              SMART_T_STEP.PART_C,
              SMART_T_STEP.UPLOAD_DOCUMENT,
              SMART_T_STEP.SURVEY,
              // SMART_T_STEP.SUMMARIZE,
            ];
          } else {
            state.router.request = [
              SMART_T_STEP.UPLOAD_PASSPORT,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_A_2,
              SMART_T_STEP.PART_B,
              SMART_T_STEP.PART_C,
              SMART_T_STEP.UPLOAD_DOCUMENT,
              SMART_T_STEP.SURVEY,
              // SMART_T_STEP.SUMMARIZE,
            ];
          }

          break;
        }
        case VISA_TYPE_ID.SMART_E:
          state.router.request = [
            SMART_T_STEP.UPLOAD_PASSPORT,
            SMART_T_STEP.PART_A_1,
            SMART_T_STEP.PART_A_2,
            SMART_T_STEP.PART_B,
            SMART_T_STEP.PART_C,
            SMART_T_STEP.UPLOAD_DOCUMENT,
            SMART_T_STEP.SURVEY,
            SMART_T_STEP.SUMMARIZE,
          ];
          break;
        case VISA_TYPE_ID.SMART_I:
          state.router.request = [
            SMART_T_STEP.UPLOAD_PASSPORT,
            SMART_T_STEP.PART_A_1,
            SMART_T_STEP.PART_A_2,
            SMART_T_STEP.PART_B,
            SMART_T_STEP.PART_C,
            SMART_T_STEP.VISA_INSUANCE,
            SMART_T_STEP.UPLOAD_DOCUMENT,
            SMART_T_STEP.SURVEY,
            SMART_T_STEP.SUMMARIZE,
          ];
          break;
        case VISA_TYPE_ID.SMART_S: {
          if (ConditionType === "2Y") {
            state.router.request = [
              SMART_T_STEP.UPLOAD_PASSPORT,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_A_2,
              SMART_T_STEP.PART_D,
              SMART_T_STEP.PART_E,
              SMART_T_STEP.HEALTH_INSUANCE,
              SMART_T_STEP.VISA_INSUANCE,
              SMART_T_STEP.UPLOAD_DOCUMENT,
              SMART_T_STEP.SURVEY,
              SMART_T_STEP.SUMMARIZE,
            ];
          } else if (ConditionType === "1YA") {
            state.router.request = [
              SMART_T_STEP.UPLOAD_PASSPORT,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_A_2,
              SMART_T_STEP.PART_B,
              SMART_T_STEP.PART_E,
              SMART_T_STEP.HEALTH_INSUANCE,
              SMART_T_STEP.VISA_INSUANCE,
              SMART_T_STEP.UPLOAD_DOCUMENT,
              SMART_T_STEP.SURVEY,
              SMART_T_STEP.SUMMARIZE,
            ];
          } else if (ConditionType === "1YB") {
            state.router.request = [
              SMART_T_STEP.UPLOAD_PASSPORT,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_A_2,
              SMART_T_STEP.PART_C,
              SMART_T_STEP.PART_E,
              SMART_T_STEP.HEALTH_INSUANCE,
              SMART_T_STEP.VISA_INSUANCE,
              SMART_T_STEP.UPLOAD_DOCUMENT,
              SMART_T_STEP.SURVEY,
              SMART_T_STEP.SUMMARIZE,
            ];
          } else if (ConditionType === "6M") {
            state.router.request = [
              SMART_T_STEP.UPLOAD_PASSPORT,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_A_2,
              SMART_T_STEP.PART_E,
              SMART_T_STEP.HEALTH_INSUANCE,
              SMART_T_STEP.VISA_INSUANCE,
              SMART_T_STEP.UPLOAD_DOCUMENT,
              SMART_T_STEP.SURVEY,
              SMART_T_STEP.SUMMARIZE,
            ];
          }
          break;
        }
        case VISA_TYPE_ID.SMART_O:
          state.router.request = [
            SMART_T_STEP.UPLOAD_PASSPORT,
            SMART_T_STEP.PART_A_1,
            SMART_T_STEP.PART_B,
            SMART_T_STEP.UPLOAD_DOCUMENT,
            SMART_T_STEP.SURVEY,
            SMART_T_STEP.SUMMARIZE,
          ];
          break;
        default:
          break;
      }

      // isExtend
      if (
        action.payload.smartserviceId === "ea67ab08-5953-4453-0830-28ed243a8d38"
      ) {
        switch (action.payload.smartserviceReferId) {
          case VISA_TYPE_ID.SMART_T:
            state.router.request = [
              SMART_T_STEP.NONE,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_B,
              SMART_T_STEP.PART_C,
              SMART_T_STEP.PART_D,
              SMART_T_STEP.UPLOAD_DOCUMENT,
            ];
            break;
          case VISA_TYPE_ID.SMART_E:
            state.router.request = [
              SMART_T_STEP.NONE,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_B,
              SMART_T_STEP.PART_C,
              SMART_T_STEP.UPLOAD_DOCUMENT,
            ];
            break;
          case VISA_TYPE_ID.SMART_I:
            state.router.request = [
              SMART_T_STEP.NONE,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_B,
              SMART_T_STEP.PART_C,
              SMART_T_STEP.PART_F,
              SMART_T_STEP.FROM_A,
              SMART_T_STEP.UPLOAD_DOCUMENT,
            ];
            break;
          case VISA_TYPE_ID.SMART_S: {
            if (ConditionType === "6MA") {
              state.router.request = [
                SMART_T_STEP.NONE,
                SMART_T_STEP.PART_A_1,
                SMART_T_STEP.PART_B,
                SMART_T_STEP.PART_E,
                SMART_T_STEP.HEALTH_INSUANCE,
                SMART_T_STEP.UPLOAD_DOCUMENT,
              ];
            } else if (ConditionType === "6MB") {
              state.router.request = [
                SMART_T_STEP.NONE,
                SMART_T_STEP.PART_A_1,
                SMART_T_STEP.PART_B,
                SMART_T_STEP.PART_E,
                SMART_T_STEP.HEALTH_INSUANCE,
                SMART_T_STEP.UPLOAD_DOCUMENT,
              ];
            } else if (ConditionType === "1YA") {
              state.router.request = [
                SMART_T_STEP.NONE,
                SMART_T_STEP.PART_A_1,
                SMART_T_STEP.PART_B,
                SMART_T_STEP.PART_C,
                SMART_T_STEP.PART_E,
                SMART_T_STEP.HEALTH_INSUANCE,
                SMART_T_STEP.UPLOAD_DOCUMENT,
              ];
            } else if (ConditionType === "1YB") {
              state.router.request = [
                SMART_T_STEP.NONE,
                SMART_T_STEP.PART_A_1,
                SMART_T_STEP.PART_B,
                SMART_T_STEP.PART_C,
                SMART_T_STEP.PART_E,
                SMART_T_STEP.HEALTH_INSUANCE,
                SMART_T_STEP.UPLOAD_DOCUMENT,
              ];
            } else if (ConditionType === "2Y") {
              state.router.request = [
                SMART_T_STEP.NONE,
                SMART_T_STEP.PART_A_1,
                SMART_T_STEP.PART_B,
                SMART_T_STEP.PART_C,
                SMART_T_STEP.HEALTH_INSUANCE,
                SMART_T_STEP.UPLOAD_DOCUMENT,
              ];
            }
            break;
          }
          case VISA_TYPE_ID.SMART_O:
            state.router.request = [
              SMART_T_STEP.NONE,
              SMART_T_STEP.PART_A_1,
              SMART_T_STEP.PART_B,
              SMART_T_STEP.PART_G,
              SMART_T_STEP.UPLOAD_DOCUMENT,
            ];
            break;
          default:
            break;
        }
      }

      // isChangeSmart
      if (action.payload.typeDocSmartFromID === "C") {
        switch (action.payload.smartserviceReferId) {
          case VISA_TYPE_ID.SMART_T:
          case VISA_TYPE_ID.SMART_E:
          case VISA_TYPE_ID.SMART_I:
          case VISA_TYPE_ID.SMART_S:
            // case VISA_TYPE_ID.SMART_O:
            state.router.request =
              getRouterChangeSmartByConditionType(ConditionType);
            // state.smartFormStep = state.router.request[1];
            break;
          default:
            break;
        }
      }

      // department request doc
      // if (action.payload.statausID === STATUS_PROCESS.RequestAddDoc) {
      //   state.router.request = [
      //     SMART_T_STEP.NONE,
      //     SMART_T_STEP.UPLOAD_DOCUMENT,
      //   ];
      // }

      if (state.smartFormStep !== "none") {
        state.stack = state.router.request.slice(
          0,
          state.router.request.indexOf(state.smartFormStep)
        );
      }
    });
  },
});
export const {
  setSmartFormStep,
  setSmartFormBackStep,
  clearSmartFormStep,
  setHomeTab,
  setIsExtension,
  setIsChange,
  setTypeChange,
} = uiSlice.actions;

export const selectSmartFormStep = (state) => state.ui.smartFormStep;
export const selectHomeTab = (state) => state.ui.homeTab;
export const selectIsExtension = (state) => state.ui.isExtension;
export const selectIsChange = (state) => state.ui.isChange;
export const selectTypeChange = (state) => state.ui.typeChange;

export default uiSlice.reducer;
